import { useTranslation } from 'react-i18next'
import { Approval } from 'constants/General'

type ApprovalFlowTranslationsType = { [x: string]: string }

const approvalFlowTranslations = (): ApprovalFlowTranslationsType => {
  const { t } = useTranslation()

  return {
    [Approval.FLOWS.FIAT_1ST_PARTY_PAYOUT]: t('approvals.firstPartyFlow'),
    [Approval.FLOWS.FIAT_3RD_PARTY_PAYOUT]: t('approvals.thirdPartyFlow'),
    // disabled temporarily
    // [Approval.FLOWS.CRYPTO_SEND]: t('approvals.cryptoSendFlow'),
    [Approval.FLOWS.CRYPTO_PAYOUT]: t('approvals.cryptoPayoutFlow'),
  }
}

export const useEnabledApprovalFlows = (enabledFlows: string[] = []) => {
  const translations = approvalFlowTranslations()

  return enabledFlows
    .filter(flow => Object.hasOwn(translations, flow))
    .map(flow => translations[flow])
    .join(', ')
}

export const useApprovalFlowsCheckboxOptions = (enabledFlows: string[] = []) => {
  const { t } = useTranslation()

  const translations = approvalFlowTranslations()
  const approvalFlowCheckboxOptions = Object.keys(translations).map(flow => ({
    label: `${t('approvals.for')} ${translations[flow]}`,
    value: flow,
    checked: enabledFlows.includes(flow),
  }))

  return {
    approvalFlowCheckboxOptions,
    approvalFlowTranslations: translations,
  }
}

// API-initiated approvals are a single checkbox. The governance endpoint returns only the enabled
// flows (no catalogue of selectable flows), so the settings option is always offered; this just
// reflects whether CRYPTO_PAYOUT_API is in the enabled set.
export const useApiInitiatedApproval = (enabledFlows: string[] = []) => {
  const { t } = useTranslation()

  return {
    isApiApprovalEnabled: enabledFlows.includes(Approval.FLOWS.CRYPTO_PAYOUT_API),
    apiApprovalLabel: t('approvals.applyApprovalRulesToApi'),
  }
}
